import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { ProdPriceDate } from './formFields/ProdPriceDate';
import { ProdPricePeriodSelect } from './formFields/ProdPricePeriodSelect';
import { ProdPriceProgSelect } from './formFields/ProdPriceProgSelect';

export const ProdPriceForm = () => {
  const rsrc = useRsrc();
  const [priceTypeToPeriodicity, setPriceTypeToPeriodicity] = useState(null);

  // Retrieve the map of Price Type to periodicity
  useEffect(() => {
    rsrc.data('md', 'PROD_PRICE_FORM_PRICE_TYPE_ENUM_DATA_PLUGIN', {}).then((res) => {
      setPriceTypeToPeriodicity(res);
    });
  }, []);

  if (!priceTypeToPeriodicity) {
    return <></>;
  }

  const augFieldDefs = (fieldToFieldDef) => {
    const priceTypeIdToCode = Object.fromEntries(
      fieldToFieldDef.priceTypeId.values.map((enumSpec) => [enumSpec.id, enumSpec.code]),
    );
    const priceTypeIdToPeriodicity = Object.fromEntries(
      Object.entries(priceTypeIdToCode).map(([id, code]) => [id, priceTypeToPeriodicity[code]]),
    );

    fieldToFieldDef.progId.component = (
      <ProdPriceProgSelect priceTypeIdToCode={priceTypeIdToCode} fieldDef={fieldToFieldDef.progId} />
    );
    fieldToFieldDef.periodId.component = (
      <ProdPricePeriodSelect priceTypeIdToPeriodicity={priceTypeIdToPeriodicity} fieldDef={fieldToFieldDef.periodId} />
    );
    fieldToFieldDef.startDate.component = (
      <ProdPriceDate priceTypeIdToPeriodicity={priceTypeIdToPeriodicity} fieldDef={fieldToFieldDef.startDate} />
    );
    fieldToFieldDef.endDate.component = (
      <ProdPriceDate priceTypeIdToPeriodicity={priceTypeIdToPeriodicity} fieldDef={fieldToFieldDef.endDate} />
    );
  };

  return <EntityForm augFieldDefs={augFieldDefs} />;
};
